import jsPDF from "jspdf";

var PAGE_WIDTH = 210;
var PAGE_HEIGHT = 297;
var MARGIN_LEFT = 20;
var MARGIN_RIGHT = 20;
var MARGIN_TOP = 25;
var MARGIN_BOTTOM = 25;
var CONTENT_WIDTH = PAGE_WIDTH - MARGIN_LEFT - MARGIN_RIGHT;

var COLORS = {
  navy: [30, 58, 95],
  primary: [0, 122, 255],
  dark: [31, 41, 55],
  body: [55, 65, 81],
  light: [107, 114, 128],
  line: [209, 213, 219],
  accent: [245, 158, 11],
};

function createPdf() {
  var pdf = new jsPDF("p", "mm", "a4");
  pdf.setFont("helvetica");
  return pdf;
}

function checkPageBreak(pdf, y, needed) {
  if (y + needed > PAGE_HEIGHT - MARGIN_BOTTOM) {
    pdf.addPage();
    return MARGIN_TOP;
  }
  return y;
}

function drawLine(pdf, y) {
  pdf.setDrawColor(COLORS.line[0], COLORS.line[1], COLORS.line[2]);
  pdf.setLineWidth(0.3);
  pdf.line(MARGIN_LEFT, y, PAGE_WIDTH - MARGIN_RIGHT, y);
  return y + 3;
}

function wrapText(pdf, text, maxWidth, fontSize) {
  pdf.setFontSize(fontSize);
  var words = text.split(" ");
  var lines = [];
  var currentLine = "";

  for (var i = 0; i < words.length; i++) {
    var testLine = currentLine ? currentLine + " " + words[i] : words[i];
    var testWidth = pdf.getTextWidth(testLine);
    if (testWidth > maxWidth && currentLine) {
      lines.push(currentLine);
      currentLine = words[i];
    } else {
      currentLine = testLine;
    }
  }
  if (currentLine) lines.push(currentLine);
  return lines;
}

function writeWrapped(pdf, y, text, fontSize, color, opts) {
  if (!text) return y;
  opts = opts || {};
  var indent = opts.indent || 0;
  var bold = opts.bold || false;
  var maxW = CONTENT_WIDTH - indent;

  pdf.setFontSize(fontSize);
  pdf.setFont("helvetica", bold ? "bold" : "normal");
  pdf.setTextColor(color[0], color[1], color[2]);

  var lines = wrapText(pdf, text, maxW, fontSize);
  var lineHeight = fontSize * 0.45;

  for (var i = 0; i < lines.length; i++) {
    y = checkPageBreak(pdf, y, lineHeight);
    pdf.text(lines[i], MARGIN_LEFT + indent, y);
    y += lineHeight;
  }
  return y;
}

function writeSectionHeader(pdf, y, title) {
  y = checkPageBreak(pdf, y, 14);
  y += 4;

  pdf.setFillColor(COLORS.navy[0], COLORS.navy[1], COLORS.navy[2]);
  pdf.rect(MARGIN_LEFT, y - 4.5, CONTENT_WIDTH, 8, "F");

  pdf.setFont("helvetica", "bold");
  pdf.setFontSize(10);
  pdf.setTextColor(255, 255, 255);
  pdf.text(title.toUpperCase(), MARGIN_LEFT + 4, y);

  y += 7;
  return y;
}

function writeLabelValue(pdf, y, label, value, indent) {
  if (!value) return y;
  indent = indent || 0;
  var labelWidth;

  y = checkPageBreak(pdf, y, 5);

  pdf.setFont("helvetica", "bold");
  pdf.setFontSize(9);
  pdf.setTextColor(COLORS.dark[0], COLORS.dark[1], COLORS.dark[2]);
  pdf.text(label + ": ", MARGIN_LEFT + indent, y);
  labelWidth = pdf.getTextWidth(label + ": ");

  pdf.setFont("helvetica", "normal");
  pdf.setTextColor(COLORS.body[0], COLORS.body[1], COLORS.body[2]);

  var remaining = CONTENT_WIDTH - indent - labelWidth;
  var lines = wrapText(pdf, value, remaining, 9);
  if (lines.length > 0) {
    pdf.text(lines[0], MARGIN_LEFT + indent + labelWidth, y);
    y += 4.2;
    for (var i = 1; i < lines.length; i++) {
      y = checkPageBreak(pdf, y, 4.2);
      pdf.text(lines[i], MARGIN_LEFT + indent + labelWidth, y);
      y += 4.2;
    }
  } else {
    y += 4.2;
  }
  return y;
}

function writeBullet(pdf, y, text, indent) {
  indent = indent || 4;
  y = checkPageBreak(pdf, y, 5);
  pdf.setFont("helvetica", "normal");
  pdf.setFontSize(9);
  pdf.setTextColor(COLORS.body[0], COLORS.body[1], COLORS.body[2]);
  pdf.text("\u2022", MARGIN_LEFT + indent, y);

  var lines = wrapText(pdf, text, CONTENT_WIDTH - indent - 5, 9);
  for (var i = 0; i < lines.length; i++) {
    y = checkPageBreak(pdf, y, 4.2);
    pdf.text(lines[i], MARGIN_LEFT + indent + 5, y);
    y += 4.2;
  }
  return y;
}

function generateCareerDossier(profileData, fullText) {
  return new Promise(function(resolve, reject) {
    try {
      var pdf = createPdf();
      var y = MARGIN_TOP;

      var name = "";
      if (profileData) {
        name =
          profileData.displayValue ||
          [profileData.firstName, profileData.lastName]
            .filter(Boolean)
            .join(" ");
      }
      name = name || "Career Profile";

      pdf.setFont("helvetica", "bold");
      pdf.setFontSize(20);
      pdf.setTextColor(COLORS.navy[0], COLORS.navy[1], COLORS.navy[2]);
      pdf.text(name, MARGIN_LEFT, y);
      y += 7;

      if (profileData && profileData.contactTitle) {
        pdf.setFont("helvetica", "normal");
        pdf.setFontSize(11);
        pdf.setTextColor(COLORS.body[0], COLORS.body[1], COLORS.body[2]);
        pdf.text(profileData.contactTitle, MARGIN_LEFT, y);
        y += 5;
      }

      pdf.setFont("helvetica", "normal");
      pdf.setFontSize(8);
      pdf.setTextColor(COLORS.light[0], COLORS.light[1], COLORS.light[2]);
      var dateStr = new Date().toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
      pdf.text("Exported " + dateStr, MARGIN_LEFT, y);
      y += 3;

      y = drawLine(pdf, y);
      y += 2;

      if (fullText) {
        y = renderStructuredText(pdf, y, fullText);
      }

      pdf.setFont("helvetica", "italic");
      pdf.setFontSize(7);
      pdf.setTextColor(COLORS.light[0], COLORS.light[1], COLORS.light[2]);
      var pageCount = pdf.internal.getNumberOfPages();
      for (var p = 1; p <= pageCount; p++) {
        pdf.setPage(p);
        pdf.text(
          "Resumation Career Profile  |  Page " + p + " of " + pageCount,
          PAGE_WIDTH / 2,
          PAGE_HEIGHT - 10,
          { align: "center" },
        );
      }

      var safeName = (name || "Career_Profile")
        .replace(/[^a-zA-Z0-9 ]/g, "")
        .replace(/\s+/g, "_");
      var today = new Date();
      var fileDateStr =
        today.getFullYear() +
        "-" +
        String(today.getMonth() + 1).padStart(2, "0") +
        "-" +
        String(today.getDate()).padStart(2, "0");

      pdf.save(safeName + "_Resumation_Profile_" + fileDateStr + ".pdf");
      resolve({ success: true });
    } catch (err) {
      reject(err);
    }
  });
}

function renderStructuredText(pdf, y, fullText) {
  var lines = fullText.split("\n");
  var sepPattern = /^={10,}$/;
  var subsepPattern = /^-{10,}$/;
  var dividerPattern = /^\s*~ ~ ~\s*$/;
  var sectionHeaderPattern = /^[A-Z][A-Z &/()0-9,'-]+$/;

  var i = 0;
  while (i < lines.length) {
    var line = lines[i];
    var trimmed = line.trim();

    if (sepPattern.test(trimmed)) {
      y = drawLine(pdf, y);
      y += 1;
      i++;
      continue;
    }

    if (subsepPattern.test(trimmed)) {
      i++;
      continue;
    }

    if (dividerPattern.test(trimmed)) {
      y += 2;
      y = checkPageBreak(pdf, y, 1);
      pdf.setDrawColor(COLORS.line[0], COLORS.line[1], COLORS.line[2]);
      pdf.setLineWidth(0.2);
      var cx = PAGE_WIDTH / 2;
      pdf.line(cx - 15, y, cx - 5, y);
      pdf.line(cx + 5, y, cx + 15, y);
      y += 4;
      i++;
      continue;
    }

    if (trimmed === "RESUMATION CAREER PROFILE") {
      i++;
      continue;
    }

    if (
      trimmed.startsWith("Exported:") ||
      trimmed === "End of Resumation Career Profile"
    ) {
      i++;
      continue;
    }

    if (trimmed === "") {
      y += 2;
      i++;
      continue;
    }

    if (
      sectionHeaderPattern.test(trimmed) &&
      trimmed.length > 3 &&
      i + 1 < lines.length &&
      subsepPattern.test(lines[i + 1].trim())
    ) {
      y = writeSectionHeader(pdf, y, trimmed);
      i += 2;
      continue;
    }

    if (trimmed.startsWith("--- ") && trimmed.endsWith(" ---")) {
      var subTitle = trimmed.replace(/^-+\s*/, "").replace(/\s*-+$/, "");
      y = checkPageBreak(pdf, y, 8);
      y += 2;
      pdf.setFont("helvetica", "bold");
      pdf.setFontSize(10);
      pdf.setTextColor(COLORS.primary[0], COLORS.primary[1], COLORS.primary[2]);
      var subLines = wrapText(pdf, subTitle, CONTENT_WIDTH, 10);
      for (var sl = 0; sl < subLines.length; sl++) {
        pdf.text(subLines[sl], MARGIN_LEFT, y);
        y += 4.5;
      }
      i++;
      continue;
    }

    if (trimmed.startsWith("* ")) {
      var bulletText = trimmed.substring(2);
      y = writeBullet(pdf, y, bulletText, 4);
      i++;
      continue;
    }

    var numberedMatch = trimmed.match(/^(\d+)\.\s+(.+)/);
    if (numberedMatch) {
      var num = numberedMatch[1];
      var rest = numberedMatch[2];

      var bracketMatch = rest.match(/^\[([^\]]+)\]\s*(.*)/);
      if (bracketMatch) {
        y = checkPageBreak(pdf, y, 6);
        pdf.setFont("helvetica", "bold");
        pdf.setFontSize(9);
        pdf.setTextColor(COLORS.navy[0], COLORS.navy[1], COLORS.navy[2]);
        pdf.text(num + ".", MARGIN_LEFT + 4, y);

        pdf.setFont("helvetica", "italic");
        pdf.setFontSize(8);
        pdf.setTextColor(COLORS.accent[0], COLORS.accent[1], COLORS.accent[2]);
        pdf.text("[" + bracketMatch[1] + "]", MARGIN_LEFT + 12, y);
        var tagW = pdf.getTextWidth("[" + bracketMatch[1] + "] ");

        if (bracketMatch[2]) {
          pdf.setFont("helvetica", "normal");
          pdf.setFontSize(9);
          pdf.setTextColor(COLORS.body[0], COLORS.body[1], COLORS.body[2]);
          var remainW = CONTENT_WIDTH - 12 - tagW;
          var restLines = wrapText(pdf, bracketMatch[2], remainW, 9);
          if (restLines.length > 0) {
            pdf.text(restLines[0], MARGIN_LEFT + 12 + tagW, y);
            y += 4.2;
            for (var rl = 1; rl < restLines.length; rl++) {
              y = checkPageBreak(pdf, y, 4.2);
              pdf.text(restLines[rl], MARGIN_LEFT + 12 + tagW, y);
              y += 4.2;
            }
          } else {
            y += 4.2;
          }
        } else {
          y += 4.2;
        }
        i++;
        continue;
      }

      y = checkPageBreak(pdf, y, 6);
      pdf.setFont("helvetica", "bold");
      pdf.setFontSize(9);
      pdf.setTextColor(COLORS.navy[0], COLORS.navy[1], COLORS.navy[2]);
      pdf.text(num + ".", MARGIN_LEFT + 4, y);

      pdf.setFont("helvetica", "normal");
      pdf.setFontSize(9);
      pdf.setTextColor(COLORS.body[0], COLORS.body[1], COLORS.body[2]);
      var numLines = wrapText(pdf, rest, CONTENT_WIDTH - 14, 9);
      if (numLines.length > 0) {
        pdf.text(numLines[0], MARGIN_LEFT + 12, y);
        y += 4.2;
        for (var nl = 1; nl < numLines.length; nl++) {
          y = checkPageBreak(pdf, y, 4.2);
          pdf.text(numLines[nl], MARGIN_LEFT + 12, y);
          y += 4.2;
        }
      } else {
        y += 4.2;
      }
      i++;
      continue;
    }

    var colonIdx = trimmed.indexOf(":");
    if (
      colonIdx > 0 &&
      colonIdx < 40 &&
      !trimmed.startsWith(" ") &&
      !trimmed.startsWith("  ")
    ) {
      var label = trimmed.substring(0, colonIdx).trim();
      var value = trimmed.substring(colonIdx + 1).trim();
      if (value) {
        var indentLevel = 0;
        if (line.startsWith("     ") || line.startsWith("   ")) indentLevel = 6;
        y = writeLabelValue(pdf, y, label, value, indentLevel);
        i++;
        continue;
      }

      y = checkPageBreak(pdf, y, 5);
      pdf.setFont("helvetica", "bold");
      pdf.setFontSize(9);
      pdf.setTextColor(COLORS.dark[0], COLORS.dark[1], COLORS.dark[2]);
      pdf.text(label + ":", MARGIN_LEFT, y);
      y += 4.5;
      i++;
      continue;
    }

    var bodyIndent = 0;
    if (line.startsWith("     ")) bodyIndent = 8;
    else if (line.startsWith("  ")) bodyIndent = 4;

    y = writeWrapped(pdf, y, trimmed, 9, COLORS.body, { indent: bodyIndent });
    i++;
  }

  return y;
}

export { generateCareerDossier };
